import moment from 'moment'

const workTimes = function () {
  let result = []
  let time = moment()
  time.minute(0).second(0)

  for (let i = 0; i < 24; i++) {
    time.hour(i)
    time.minute(0).second(0)
    let item = {
      id: time.format('HH:mm:ss').toString(),
      name: time.format('HH:mm').toString(),
      selected: false
    }
    result.push(item)
    let item30 = {
      id: time.minute(30).format('HH:mm:ss').toString(),
      name: time.minute(30).format('HH:mm').toString(),
      selected: false
    }

    result.push(item30)
  }

  return result
}

export default workTimes



// WEBPACK FOOTER //
// ./src/helpers/workTimes.js